<template>
  <b-card-body class="collapse-pb" v-if="visible">
    <!-- if don't have timeslots -->
    <div
      v-if="!existTimeslots && !getErrorTimeslotStatus"
      class="w-100 text-center m-1 mt-3 mb-3"
    >
      <small>{{ i18n.t("all-timeslots-are-booked-up") }}</small>
    </div>
    <!-- if timeslot have error -->
    <div
      v-if="getErrorTimeslotStatus"
      class="w-100 text-center m-1 mt-3 mb-3"
    >
      <small class="m-1">{{ i18n.t("error.something_wrong") }}</small>
    </div>
    <!-- timeslots-->
    <b-col
      v-for="(day, k) in getAllTimeslots.days"
      :key="k"
      align="center"
      class="mb-1 queue-day"
    >
      <h4
        v-show="getAllTimeslots.timeslots[k].length"
        class="ml-3 queue-data"
        align="start"
      >
        {{ toLocaleStringSupportsLocales(day, getLanguage, {weekday: 'short', month: 'long', day: '2-digit'}) }}
        <small
          v-if="new Date().getDate() === new Date(day).getDate()"
          class="text-secondary"
        >
          ({{ i18n.t('today') }})
        </small>
      </h4>
      <span
        v-for="(timeslot, i) in getAllTimeslots.timeslots[k]"
        :key="i"
      >
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="pl-0 pr-0 queue-button buttons-effect"
          size="sm"
          :style="`border: 1px solid ${getWidgetSettings.main_color} !important; color: ${getWidgetSettings.main_color}`"
          @click="showForm(timeslot, day)"
        >
          {{ timeslot.slice(0,5) }}
        </b-button>
      </span>
    </b-col>
  </b-card-body>
</template>

<script>
import {
  BButton,
  BCardBody,
  BCol,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import i18n from '@/libs/i18n'

export default {
  name: 'GridCalendar',
  directives: {
    Ripple,
  },
  components: {
    BCardBody,
    BCol,
    BButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    existTimeslots: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n,
    }
  },
  computed: mapGetters(['getWidgetSettings', 'getLanguage', 'getErrorTimeslotStatus', 'getAllTimeslots']),
  methods: {
    toLocaleStringSupportsLocales(day, locale, options) {
      try {
        new Date(day).toLocaleString(locale, options)
      } catch (e) {
        return new Date(day).toDateString()
      }
      return new Date(day).toLocaleString(locale, options)
    },
    showForm(timeslot, day) {
      this.$emit('openForm', { timeslot: timeslot, day: day })
    },
  },
}
</script>

<style scoped>

</style>
